export default __webpack_public_path__ + "static/media/Banners_back2school_gmm_330x330.f7e60161.webp";